// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`21.1|154.41500|123.0|159.00000|000.0|H|N|
21.2|151.40000|110.9|159.37500|000.0|H|N|
21.3|151.22000|192.8|151.22000|192.8|L|N|
21.4|153.81500|123.0|155.82000|123.0|H|N|
21.5|153.89000|123.0|153.89000|123.0|L|N|
21.6|156.12000|123.0|156.12000|123.0|L|N|
21.7|154.31000|131.8|154.31000|131.8|H|N|
21.8|156.07500|156.7|156.07500|156.7|H|N|
21.9|154.28000|156.7|154.28000|156.7|H|N|
21.10|154.26500|156.7|154.26500|156.7|L|N|
21.11|154.29500|156.7|154.29500|156.7|L|N|
21.12|154.30250|156.7|154.30250|156.7|L|N|
21.13|151.38500|192.8|151.38500|192.8|L|N|
21.14|151.44500|192.8|151.44500|192.8|L|N|
21.15|151.46000|192.8|151.46000|192.8|L|N|
21.16|153.95000|100.0|156.01500|100.0|H|N|
21.17|154.43000|100.0|154.43000|100.0|L|N|
21.18|154.19000|100.0|154.19000|100.0|L|N|
21.19|151.25000|192.8|151.25000|192.8|L|N|
21.20|151.32500|131.8|159.36000|000.0|H|N|
21.21|153.96500|100.0|156.33000|000.0|H|N|
21.22|154.35500|107.2|158.89500|000.0|H|N|
21.23|153.93500|100.0|158.88000|100.0|H|N|
21.24|153.77000|100.0|153.77000|100.0|H|N|
21.25|155.98500|186.2|154.01000|000.0|H|N|
21.26|153.83000|000.0|153.83000|000.0|H|N|
21.27|170.55000|000.0|164.87500|000.0|H|N|
21.28|171.42500|000.0|163.16250|000.0|H|N|
21.29|173.18750|000.0|164.80000|000.0|H|N|
21.30|151.37000|146.2|159.28500|000.0|H|N|
21.31|154.17500|100.0|158.98500|100.0|H|N|YUB PRIM (Yuba City)
21.32|154.25000|100.0|155.86500|000.0|H|N|YBA CMD (Yuba Co)
21.33|154.34000|103.5|156.01500|103.5|H|N|YUBA CITY FD TAC 1
21.34|154.20500|100.0|154.20500|100.0|L|N|YUBA COUNTY TAC 1
21.35|154.31000|000.0|154.31000|100.0|L|N|YUBA COUNTY TAC 2
21.36|154.07000|000.0|154.07000|110.9|L|N|YUBA COUNTY TAC 3
21.37|155.26500|100.0|159.04500|100.0|H|N|YUBA COUNTY TAC 4
21.38|155.29500|100.0|154.13000|123.0|H|N|YUBA COUNTY TAC 5
21.39|154.40000|000.0|158.83500|000.0|H|N|
21.40|154.38500|000.0|154.38500|123.0|L|N|
21.41|154.37000|100.0|158.79000|100.0|H|N|
21.42|154.32500|000.0|154.32500|100.0|L|N|
21.43|155.08500|103.5|155.08500|103.5|H|N|
21.44|158.82000|167.9|158.82000|167.9|H|N|
21.45|155.92500|103.5|155.92500|103.5|L|N|
21.46|154.35500|103.5|154.35500|103.5|L|N|
21.47|155.86500|103.5|155.86500|103.5|L|N|
21.48|154.23500|103.5|154.23500|103.5|L|N|
21.49|153.86000|103.5|153.86000|103.5|L|N|
21.50|154.25000|103.5|154.25000|103.5|L|N|
21.51|154.05500|103.5|154.05500|103.5|L|N|
21.52|154.19000|110.9|153.77000|110.9|H|N|
21.53|155.16000|000.0|155.16000|000.0|L|N|
21.54|158.90250|107.2|155.27250|107.2|H|N|
21.55|153.79250|107.2|153.79250|107.2|L|N|
21.56|155.75250|000.0|155.75250|156.7|L|N|
21.57|151.13750|156.7|151.13750|156.7|L|N|
21.58|151.23500|141.3|159.25500|141.3|H|N|
21.59|151.23500|141.3|151.23500|141.3|L|N|
21.60|154.72500|107.2|000.00000|000.0||N|RX Only-LE Channel
21.61|155.91000|100.0|000.00000|000.0||N|RX Only-LE Channel
21.62|151.49000|114.8|000.00000|000.0||N|RX Only-LE Channel
21.63|151.49000|114.8|000.00000|000.0||N|RX Only-LE Channel
21.64|151.49000|114.8|000.00000|000.0||N|RX Only-LE Channel
21.65|151.49000|114.8|000.00000|000.0||N|RX Only-LE Channel
21.66|151.49000|114.8|000.00000|000.0||N|RX Only-LE Channel
21.67|154.78500|D411|000.00000|000.0||N|RX Only-LE Channel
21.68|155.71500|100.0|000.00000|000.0||N|RX Only-LE Channel
21.69|155.04000|D411|000.00000|000.0||N|RX Only-LE Channel
21.70|154.87500|D411|000.00000|000.0||N|RX Only-LE Channel
21.71|151.05500|000.0|000.00000|000.0||N|RX Only-LE Channel
21.72|155.94000|000.0|000.00000|000.0||N|RX Only-LE Channel
21.73|158.90250|107.2|000.00000|000.0||N|RX Only-LE Channel
21.74|158.90250|107.2|000.00000|000.0||N|RX Only-LE Channel
21.75|153.79250|107.2|000.00000|000.0||N|RX Only-LE Channel
21.76|168.62500|000.0|168.62500|110.9|L|N|Emergency
22.1|151.25000|123.0|159.40500|000.0|H|N|
22.2|151.25750|192.8|151.25750|192.8|L|N|
22.3|151.17500|192.8|151.17500|192.8|L|N|
22.4|151.34000|192.8|151.34000|192.8|L|N|
22.5|151.37000|192.8|151.37000|192.8|L|N|
22.6|151.38500|192.8|151.38500|192.8|L|N|
22.7|151.40000|192.8|151.40000|192.8|L|N|
22.8|151.33250|192.8|151.33250|192.8|L|N|
22.9|151.22000|192.8|151.22000|192.8|L|N|
22.10|159.26250|192.8|159.26250|192.8|L|N|
22.11|159.36750|192.8|159.36750|192.8|L|N|
22.12|151.35500|103.5|159.30000|000.0|H|N|
22.13|151.26500|103.5|159.33000|000.0|H|N|
22.14|151.19000|103.5|159.22500|000.0|H|N|
22.15|173.18750|000.0|164.80000|000.0|H|N|
22.16|171.47500|000.0|164.91250|000.0|H|N|
22.17|169.95000|000.0|164.10000|000.0|H|N|
22.18|170.73750|000.0|164.98750|000.0|H|N|
22.19|173.78750|000.0|162.48750|000.0|H|N|
22.20|169.95000|000.0|164.10000|000.0|H|N|
22.21|170.55000|000.0|164.87500|000.0|H|N|
22.22|171.42500|000.0|163.16250|000.0|H|N|
22.23|171.50000|000.0|164.82500|000.0|H|N|
22.24|168.05000|000.0|168.05000|000.0|L|N|
22.25|168.20000|000.0|168.20000|000.0|L|N|
22.26|168.60000|000.0|168.60000|000.0|L|N|
22.27|166.55000|000.0|166.55000|000.0|L|N|
22.28|167.11250|000.0|167.11250|000.0|L|N|
22.29|168.23750|000.0|168.23750|000.0|L|N|
22.30|167.60000|000.0|167.60000|000.0|L|N|
22.31|166.87500|000.0|166.87500|000.0|L|N|
22.32|167.50000|000.0|167.50000|000.0|L|N|
22.33|171.62500|000.0|164.25000|000.0|H|N|
22.34|172.81250|000.0|166.31250|000.0|H|N|
22.35|168.30000|000.0|168.30000|000.0|L|N|
22.36|169.40000|000.0|169.40000|000.0|L|N|
22.37|171.62500|000.0|171.62500|136.5|H|N|
22.38|154.44500|000.0|154.01000|000.0|H|N|
22.39|154.32500|000.0|154.32500|000.0|L|N|
22.40|156.07500|156.7|156.07500|156.7|H|N|
22.41|154.28000|156.7|154.28000|156.7|H|N|
22.42|154.26500|156.7|154.26500|156.7|L|N|
22.43|154.29500|156.7|154.29500|156.7|L|N|
22.44|154.19000|000.0|153.77000|110.9|H|N|
22.45|155.86500|000.0|155.86500|000.0|L|N|
22.46|154.23500|000.0|154.23500|000.0|L|N|
22.47|154.35500|000.0|154.35500|000.0|L|N|
22.48|153.86000|000.0|153.86000|000.0|L|N|
22.49|153.92000|146.2|158.83500|146.2|H|N|
22.50|154.18250|167.9|158.83500|167.9|H|N|
22.51|153.86000|127.3|158.83500|127.3|H|N|
22.52|156.12000|94.8|158.83500|110.9|H|N|
22.53|154.13750|151.4|158.83500|151.4|H|N|
22.54|154.19750|107.2|158.83500|107.2|H|N|
22.55|155.61750|136.5|158.83500|136.5|H|N|
22.56|154.08500|131.8|158.83500|131.8|H|N|
22.57|154.97250|141.3|158.83500|141.3|H|N|
22.58|154.37750|123.0|158.83500|123.0|H|N|
22.59|155.99750|156.7|158.83500|156.7|H|N|
22.60|155.64000|131.8|158.79750|131.8|H|N|
22.61|155.64000|127.3|158.79750|127.3|H|N|
22.62|155.64000|123.0|158.79750|123.0|H|N|
22.63|155.64000|100.0|158.79750|100.0|H|N|
22.64|155.14500|000.0|155.14500|000.0|L|N|
22.65|156.18000|000.0|155.14500|000.0|L|N|
22.66|155.64000|151.4|158.79750|151.4|H|N|
22.67|155.64000|162.2|154.64000|162.2|L|N|
22.68|155.08500|103.5|158.95500|0.000|H|N|
22.69|155.92500|103.5|155.92500|103.5|L|N|
22.70|151.97000|000.0|151.97000|000.0|L|N|
22.71|154.25000|103.5|154.25000|103.5|L|N|
22.72|169.81250|110.9|163.02500|110.9|H|N|
22.73|172.46250|110.9|165.60000|110.9|H|N|
22.74|172.43750|110.9|166.33750|110.9|H|N|
22.75|169.78750|110.9|164.16250|110.9|H|N|
22.76|163.71250|000.0|163.71250|000.0|L|N|
22.77|169.98750|146.2|162.23750|173.8|L|N|
22.78|168.31250|000.0|168.31250|000.0|L|N|
22.79|171.67500|000.0|171.67500|114.8|L|N|
22.80|172.52500|000.0|172.52500|000.0|L|N|
22.81|168.08750|000.0|168.08750|000.0|L|N|
22.82|166.48750|000.0|166.48750|000.0|L|N|
22.83|166.68750|000.0|166.68750|000.0|L|N|
22.84|155.34000|000.0|155.34000|156.7|L|N|
22.85|155.34750|000.0|155.34750|156.7|L|N|
22.86|158.74500|000.0|158.74500|118.8|H|N|
22.87|153.75500|000.0|154.98000|000.0|L|N|
22.88|162.50000|000.0|000.00000|000.0|L|W|
22.89|154.16000|000.0|159.19500|000.0|H|N|
22.90|154.87500|000.0|155.59500|000.0|H|N|RX Only-LE Channel
22.91|155.31000|000.0|000.00000|000.0||N|RX Only-LE Channel
22.92|158.88000|000.0|000.00000|000.0||N|RX Only-LE Channel
22.93|153.92000|000.0|158.83500|000.0|H|N|RX Only-LE Channel
22.94|156.09000|000.0|000.00000|000.0||N|RX Only-LE Channel
22.95|154.74000|74.4|000.00000|000.0||N|RX Only-LE Channel
22.96|155.52000|000.0|000.00000|000.0||N|RX Only-LE Channel
22.97|153.92000|000.0|000.00000|000.0||N|RX Only-LE Channel
22.98|155.77500|000.0|000.00000|000.0||N|RX Only-LE Channel
22.99|155.16000|000.0|000.00000|000.0||N|RX Only-LE Channel
22.100|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
